import TooManyAttemptsErrorModal from "./TooManyAttemptsErrorModal";

export default TooManyAttemptsErrorModal;
